import ResultDialog from 'app/shared/ui/elements/ResultDialog';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  closeLabel?: string;
}

/** Error result dialog. Replaces the `SuccessModal unsuccess` simulation. */
const ErrorModal = ({ open, title, onClose, closeLabel }: Props) => {
  const { t } = useTranslation();

  return (
    <ResultDialog
      open={open}
      variant='error'
      title={title}
      actions={[{ label: closeLabel ?? t('commonActions.close'), onClick: onClose }]}
    />
  );
};

export default ErrorModal;
